import { render, staticRenderFns } from "./AirticketorderRight.vue?vue&type=template&id=27c19b3a&scoped=true"
import script from "./AirticketorderRight.vue?vue&type=script&lang=js"
export * from "./AirticketorderRight.vue?vue&type=script&lang=js"
import style0 from "./AirticketorderRight.vue?vue&type=style&index=0&id=27c19b3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c19b3a",
  null
  
)

export default component.exports